import React from "react";
import SensorBase from "./SensorBase";
import { TDataItem, TSensorDataResponse } from "../../../services/sensorData.service";
import { TCustomProcessFn } from "../types";
import { generateColorForItem } from "../util";

const FIELD = "airTemp";
const UNIT = "°C";

const customProcessFn: TCustomProcessFn = (
  graphData: TSensorDataResponse
) => {

  const updatedSample = (graphData.data ?? []).map((item:TDataItem) => ({
    ...item,
    color: generateColorForItem(
      Number(item.airTemp),
      item.minThresholdValue,
      item.minOptimalValue,
      item.maxOptimalValue,
      item.maxThresholdValue
    ),   
  }));

  return {
    sample: updatedSample,  
    min: graphData.min,  
    max: graphData.max,  
    avg: graphData.avg,  
    color: updatedSample.map((item) => item.color),  
  };
};

const AirTemperature: React.FC = () => {
  return (
    <SensorBase field={FIELD} unit={UNIT} customProcessFn={customProcessFn}></SensorBase>
  );
};

export default AirTemperature;
